<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <div style="font-size:1.0rem;font-weight:bold;">基础信息</div>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="服务商" prop="providerName">
              {{ form.providerName }}
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="结算周期" prop="billCycleNum">
              {{ '每' + form.billCycleNum + '月' }}
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="账单时间段" prop="billMonthStr">
              {{ form.billMonthStr }}
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="结算状态" prop="settlementFlag">
              {{ form.settlementFlag == 1 ? '已结算' : '未结算' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <div style="font-size:1.0rem;font-weight:bold;">服务统计</div>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="订单情况" style="font-weight:bold;" prop="completedCount">
              <el-col :span="18">
                <div style="font-weight:initial;">
                  {{ '完成服务单: ' + serviceStatistic.completedCount + '单' }}
                </div>
              </el-col>
              <el-col :span="6">
                <div style="font-weight:initial;">
                  {{ '金额总计: ' + serviceStatistic.totalAmount + '元' }}
                </div>
              </el-col>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="客户评价" style="font-weight:bold;" prop="qualifyCount">
              <el-col :span="18">
                <div style="font-weight:initial;">
                  {{
                    '好评: ' +
                      serviceStatistic.qualifyCount +
                      '  差评: ' +
                      serviceStatistic.unQualifyCount +
                      '  未评价: ' +
                      serviceStatistic.unEvaluateCount
                  }}
                </div>
              </el-col>
              <el-col :span="6">
                <div style="font-weight:initial;">
                  {{ '好评率: ' + serviceStatistic.qualifyRate + '%' }}
                </div>
              </el-col>

              <el-col
                :span="18"
                v-if="
                  serviceStatistic.evaluateStatisticList &&
                    serviceStatistic.evaluateStatisticList.length > 0
                "
              >
                <span
                  style="font-weight:initial;"
                  v-for="(item, index) in serviceStatistic.evaluateStatisticList"
                  :key="index"
                >
                  {{ item.targetName + ':' + item.avgLevel }}
                </span>
              </el-col>
              <el-col :span="18" v-else>
                <div style="font-weight:initial;">{{ '暂无' }}</div>
              </el-col>

              <el-col
                :span="6"
                v-if="
                  serviceStatistic.avgEvaluateScore &&
                    serviceStatistic.avgEvaluateScore + '' !== '' &&
                    serviceStatistic.avgEvaluateScore + '' !== 'null'
                "
              >
                <div style="font-weight:initial;">
                  {{ '综合评分: ' + serviceStatistic.avgEvaluateScore }}
                </div>
              </el-col>
              <el-col :span="6" v-else>
                <div style="font-weight:initial;">{{ '综合评分: ' + '暂无' }}</div>
              </el-col>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="回访满意度" style="font-weight:bold;" prop="satisfiedCount">
              <el-col :span="18">
                <div style="font-weight:initial;">
                  {{
                    '次数: ' +
                      serviceStatistic.returnVisitCount +
                      '次' +
                      '  满意: ' +
                      serviceStatistic.satisfiedCount +
                      '次' +
                      '  一般: ' +
                      serviceStatistic.commonlyCount +
                      '次' +
                      '  不满意: ' +
                      serviceStatistic.dissatisfiedCount +
                      '次'
                  }}
                </div>
              </el-col>
              <el-col :span="6">
                <div style="font-weight:initial;">
                  {{ '满意度: ' + serviceStatistic.satisfiedRate + '%' }}
                </div>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <div style="font-size:1.0rem;font-weight:bold;">结算信息</div>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label-width="115px" label="服务单金额总计" prop="serviceAmount">
              {{ form.serviceAmount + '元' }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="115px" label="结算后退款金额" prop="refundAmount">
              {{ (form.serviceRefundAmount || 0 ) + '元' }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="实际结算" prop="actualAmount">
              <div v-if="model === 'view'">
                {{ form.actualAmount + '' === 'null' ? '暂无' : form.actualAmount + '元' }}
              </div>
              <el-input
                v-else
                clearable
                :disabled="model === 'view'"
                v-model="form.actualAmount"
                placeholder="实际结算"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="结算依据/说明" prop="description">
              <!-- :disabled="model==='view'"  -->
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.description"
                placeholder="如 实际结算=完成服务单金额总计*（平台佣金）95%*(0.7+ 0.2* 好评率86.7%  +0.1*回访满意度*75%）"
                type="textarea"
                maxlength="300"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- v-if="model != 'view'" -->
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '结算' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import {
  getWarehouseWarnSetting,
  getProviderList,
  saveCommunityInfo,
  getServiceStatistic,
  updateSettlement,
} from '../api/serveItemManage';
import vUpload from '../components/mutil-upload.vue';
import md5 from 'js-md5';
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue';
export default {
  components: { vUpload, choicePeople },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'singlePeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 1,
      },
      roleTypeList: [],
      provideList: [],
      providerIdList: [],
      customerTypeList: [
        {
          name: '新用户',
          id: '1',
        },
        {
          name: '系统已有用户',
          id: '2',
        },
      ],
      form: {
        projectId: '',
        nursinghomeId: '',
        downWarnValue: '',
        upWarnValue: '',
        releaseMode: '',
        authPictureUrlList: [],
        contactPictureUrlList: [],
        moduleTypesIds: [],
        moduleTypes: '',
        password_: '',
        password: '',
        id: '',
        providerName: '',
        description: '',
      },
      formRules: {
        actualAmount: [{ required: true, message: '实际结算不能为空', trigger: 'blur' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
      projectList: [],
      typeList: [],
      moduleTypeList: [],
      communityTypeList: [],
      serviceStatistic: [],
      sexList: [
        {
          dictKey: 1,
          dictValue: '男',
        },
        {
          dictKey: '2',
          dictValue: '女',
        },
        {
          dictKey: '3',
          dictValue: '未知',
        },
      ],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    customerTypeChange(id) {
      this.form.id = '';
      this.choicePeopleOption.selectList = [];
    },
    userIdChange(val) {
      let self = this;
      this.userList.forEach((ele) => {
        if (ele.id === val) {
          self.form.tel = ele.tel;
          self.form.idNumber = ele.idNumber;
        }
      });
    },
    consumableIdChange() {
      this.form.warehouseList = [];

      if (this.form.consumableId != '') {
        getWarehouseWarnSetting({
          nursinghomeId: this.form.nursinghomeId,
          type: '0',
          consumableId: this.form.consumableId,
        }).then((res) => {
          this.form = res.data;

          this.form.type = 0;
        });
      }
    },
    async initData() {
      console.log(this.form, this.model);
      getProjectList().then((res) => {
        this.projectList = res.data;
        getProviderList({ projectId: this.row.projectId, status: 1 }).then((res) => {
          this.providerIdList = res.data;
        });
      });

      this.choicePeopleOption.projectId = this.form.projectId;
      console.log('getBasicInforDetail======================>');
      if (this.model === 'add') {
      } else {
        this.form = this._.cloneDeep(this.row);
        // this.form.moduleTypesIds = this.form.moduleTypes.split(',');
      }
      // getDictionary('nursinghome_device_category_type').then((res) => {
      //   this.deviceCategoryList = res.data;
      // });
      // getDictionary('nursinghome_payment_type').then((res) => {
      //   this.paymentTypeList = res.data;
      // });

      // getDictionary('out_order_service_provider_type').then((res) => {
      //   this.typeList = res.data;
      // });
      // getDictionary('out_order_module_type').then((res) => {
      //   this.moduleTypeList = res.data;
      // });
      getDictionary('out_order_service_provider_user_role_type').then((res) => {
        this.roleTypeList = res.data;
      });
      getDictionary('out_order_service_community_type').then((res) => {
        this.communityTypeList = res.data;
      });

      if (this.model === 'add') {
        // this.form.nursinghomeId = this.nursinghomeId;
        // await getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
        //   this.matetialList = res.data;
        //   if (this.matetialList.length > 0) {
        //     this.form.consumableId = this.matetialList[0].id;
        //   }
        // });
        //通过物料id获取仓库数据
        // if (this.form.consumableId != '') {
        //   this.consumableIdChange();
        // }
      } else {
        getServiceStatistic({ settlementId: this.form.id }).then((res) => {
          this.serviceStatistic = res.data;
        });
      }
      //this.form.description = '';
      console.log('this.form.actualAmount============>', this.form.actualAmount);
      // if(this.form.actualAmount+''==='null'){
      //   this.form.actualAmount = '';
      // }
    },
    saveRecord() {
      if (this.form.moduleTypesIds && this.form.moduleTypesIds.length > 0) {
        this.form.moduleTypes = this.form.moduleTypesIds.join(',');
      }
      console.log('this.form.description====saveRecord===>', this.form.description);
      // this.form.password = md5(this.form.password_)
      if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveCommunityInfo(this.form).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            updateSettlement({
              id: this.form.id,
              actualAmount: this.form.actualAmount,
              description: this.form.description,
            }).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
